// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");

const $ = require('jquery');

/* code for HTML search filter */

$(document).ready(function(){
  $("#search").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $("tbody tr").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });
});


$(window).on('resize', function(){
    var win = $(this); //this = window
    if (win.width() >= 700) {
        $("#2019-header").html("Number of students (2019)");
        $("#2020-header").html("Number of students (2020)");
        $("#2021-header").html("Number of students (2021)");
    };
});